import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

const GetGLP1Orders = (page = 1, size = 20) => {
    return useQuery(
        ["get-glp1-orders", page, size],
        () =>
            request({
                url: `glp1Dashboard/admin/orders?page=${page}&size=${size}`,
                method: "GET",
            }),
        {
            refetchInterval: 60000,
            keepPreviousData: true,
        }
    );
};

export default GetGLP1Orders;
